import { LandingCardBase } from '@/components/landing/LandingCardBase';
import WhereToBuyBtnEnhanced from '@/components/button/where-to-buy-btn-enhanced';
import Text from '@/components/common/Text';
import Heading from '@/components/common/Heading';
import { useDeviceDetect } from '@/utils/useDeviceDetect';
import { useStore } from 'zustand';
import { useMapStore } from '@/stores/map/mapStore';

export const WhereToBuy = () => {
  const isMobile = useDeviceDetect();
  const { modalMapOpen, setModalMapOpen } = useStore(useMapStore, (state) => ({
    modalMapOpen: state.modalMapOpen,
    setModalMapOpen: state.setModalMapOpen,
  }));

  return (
    <>
      <div className='w-full'>
        <LandingCardBase className='p-9'>
          <div className='mr-auto flex w-full flex-col items-start justify-start gap-y-16 md:w-10/12'>
            <div className='flex flex-grow flex-col items-start justify-start gap-y-5'>
              <div className='relative flex h-10 w-10 flex-row items-center justify-center'>
                <svg
                  width='40'
                  height='40'
                  viewBox='0 0 40 40'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M5.26746 24.0176V34.7319C5.26746 35.087 5.40856 35.4278 5.65973 35.679C5.91088 35.93 6.25154 36.0712 6.60674 36.0712H33.3925C33.7476 36.0712 34.0883 35.93 34.3396 35.679C34.5906 35.4278 34.7317 35.087 34.7317 34.7319V24.0176'
                    stroke='#282A2B'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M3.92859 11.9644L6.91919 5.4848C7.357 4.53618 8.30645 3.92871 9.35122 3.92871H30.6489C31.6936 3.92871 32.6431 4.53618 33.0808 5.4848L36.0714 11.9644H3.92859Z'
                    stroke='#282A2B'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M3.92859 11.9648H14.6429V14.6434C14.6429 17.6021 12.2444 20.0006 9.28573 20.0006C6.32706 20.0006 3.92859 17.6021 3.92859 14.6434V11.9648Z'
                    stroke='#282A2B'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M14.6425 11.9648H25.3567V14.6434C25.3567 17.6021 22.9583 20.0006 19.9996 20.0006C17.0409 20.0006 14.6425 17.6021 14.6425 14.6434V11.9648Z'
                    stroke='#282A2B'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M25.3573 11.9648H36.0716V14.6434C36.0716 17.6021 33.6732 20.0006 30.7144 20.0006C27.7558 20.0006 25.3573 17.6021 25.3573 14.6434V11.9648Z'
                    stroke='#282A2B'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M14.6425 30.7984C14.6425 27.8399 17.0409 25.4414 19.9996 25.4414C22.9583 25.4414 25.3567 27.8399 25.3567 30.7984V36.072H14.6425V30.7984Z'
                    stroke='#282A2B'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </div>
              <Heading size={3}>Where to buy?</Heading>
              <Text size='paragraph'>
                Explore nearby dealers. Get the product you love.
              </Text>
            </div>
            <WhereToBuyBtnEnhanced
              isMobile={isMobile}
              setMapOpen={setModalMapOpen}
              title={'Find a dealer'}
            />
          </div>
        </LandingCardBase>
      </div>
    </>
  );
};
